import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataBaseProvider } from '../../providers/data-base/data-base';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Generated class for the UserDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-user-details',
  templateUrl: 'user-details.html',
})
export class UserDetailsPage {
  userKey;
  userForm: FormGroup;
  userData: any;
  isAdmin = false;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $db: DataBaseProvider,
    public $auth: AuthServiceProvider,
    public alertCtrl: AlertController) {
    this.userForm = new FormGroup({
      email: new FormControl({ value: '', disabled: true }, [Validators.required]),
      name: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required]),
      tenantCode: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl(''),
      district: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      pinCode: new FormControl('', [Validators.required]),
      gstNumber: new FormControl(''),
    })
  }

  ionViewDidLoad() {
    this.userKey = this.navParams.get('userKey');
    // check the user is a admin 
    this.$auth.isAdmin().subscribe(data => {
      this.isAdmin = data.exist ? data.exist : false;
      console.log(this.isAdmin);
    })
    this.getUserDetails();

  }

  getUserDetails() {
    this.$db.getUserInfo(this.userKey ? this.userKey : this.$auth.getCurrentUserKey()).pipe(take(1)).subscribe(userData => {
      this.userForm.patchValue(userData);
      this.userData = userData;
    })
  }

  reset() {
    this.userForm.reset();
    this.getUserDetails();
  }

  save(userDetails: any) {
    this.$db.updateUserInfo(userDetails, this.userKey).then(_ => {
      this.alertCtrl.create({
        title: 'Update Done',
        message: 'User details updated',
        buttons: ['Ok']
      }).present();
      this.navCtrl.pop();
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/user-details/user-details.ts